import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Warning, X } from "@phosphor-icons/react";

// Top-of-page red/yellow strip that polls /api/health/strip every 30 s. Hides
// itself when everything's green so the UI stays clean during normal ops.
export default function HealthStrip() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    const tick = () => http.get("/health/strip")
      .then(({ data }) => { if (alive) setData(data); })
      .catch(() => {});
    tick();
    const h = setInterval(tick, 30_000);
    return () => { alive = false; clearInterval(h); };
  }, []);

  if (!data || data.severity === "ok" || dismissed) return null;

  const bg = data.severity === "critical" ? "bg-red-600" : "bg-amber-500";
  const label = data.severity === "critical" ? "CRITICAL" : "DEGRADED";

  return (
    <div
      data-testid="health-strip"
      data-severity={data.severity}
      className={`${bg} text-white px-3 py-1.5 text-xs font-mono flex items-center justify-between gap-2 border-b border-white/20`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Warning size={14} weight="fill" className="shrink-0" />
        <span className="font-bold uppercase tracking-wide">{label}</span>
        <span className="truncate opacity-90">· {data.message}</span>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <span className="hidden md:inline opacity-80">
          disk {data.disk_pct}% · {data.containers?.filter(c => !c.healthy && c.name !== "docker-sock").map(c => c.name).join(", ") || "containers ok"}
        </span>
        <button
          onClick={() => setDismissed(true)}
          data-testid="health-strip-dismiss"
          className="hover:opacity-70"
          title="Dismiss until next page load"
        >
          <X size={12} weight="bold" />
        </button>
      </div>
    </div>
  );
}
